import {TIMELINE_URL} from "../constants/api";
import {
  FEEDBACK_FUNNY,
  FEEDBACK_HAPPY,
  FEEDBACK_LOVE,
  FEEDBACK_LUCKY,
  FEEDBACK_POSITIVE,
  FEEDBACK_RECEIVED,
  TIMELINE_LIST_LIMIT,
  TYPE_IMAGE
} from "../constants";
import {
  TIMELINE_FETCH,
  TIMELINE_HAS_MORE,
  TIMELINE_RESET
} from "../constants/actionTypes";
import relativesImage from '../../../../assets/img/relatives_211x211.png';
import seniorsImage from '../../../../assets/img/seniors_211x211.png';
import {getStorageImageUrl} from "../../../shared/actions";
import {NO_IMAGE} from "../../members/constants";
import {requestAuth} from "../../../request";

/**
 * This function parses/converts the fetched data to the right/needed format
 * to build up the timeline/timeline-items.
 *
 * @param {array} data This parameter contains the the body of the request to
 *                      timeline-endpoint of the relatives api.
 * @returns {object} The object contains the property 'type', which will say that the fetching was successful
 *                   and the property 'payload' which contains a list of data entries to build up the timeline.
 */
export function fetchAction(data) {
  const validFeedbacks = [
    FEEDBACK_POSITIVE,
    FEEDBACK_HAPPY,
    FEEDBACK_LUCKY,
    FEEDBACK_LOVE,
    FEEDBACK_FUNNY
  ];

  return {
    type: TIMELINE_FETCH,
    payload: data.map((item) => {
      return {
        type: TYPE_IMAGE,
        image: {
          url: getStorageImageUrl(item.cf_prev_url),
          hash: item.cf_url
        },
        sender: {
          id: item.cf_cust_id,
          name: `${item.c_prename} ${item.c_lastname}`,
          image: relativesImage
        },
        recipient: {
          id: item.p_prof_id,
          name: `${item.p_firstname} ${item.p_lastname}`,
          image: item.p_prof_img === NO_IMAGE
            ? seniorsImage
            : getStorageImageUrl(item.p_prof_img)
        },
        date: item.cf_last_edit,
        title: item.cf_title,
        rights: item.cf_rights,
        feedback: validFeedbacks.includes(item.cf_comment)
          ? item.cf_comment
          : item.cf_download_finished
            ? FEEDBACK_RECEIVED
            : ""
      };
    })
  };
}

/**
 * Get the needed data to build up the timeline. Starting from the offset.
 *
 * The function will receive a list, which contains the single elements of the timeline
 * i.e. recipient, imgUrl etc.
 * This list will be stored to the redux store as 'timeline'.
 *
 * @param {int} offset Defines the starting point of the list, which should be retrieved.
 * @returns {function(dispatch): Promise<any>} promised thunk to be dispatched
 */
export function getTimeline(offset) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      requestAuth()
        .post(TIMELINE_URL)
        .send(
          {
            list_offset: offset,
            list_length: TIMELINE_LIST_LIMIT
          }
        )
        .then((res) => {
          if (res.body.length) {
            resolve(
              dispatch(
                fetchAction(res.body)
              )
            );
          } else {
            resolve(
              dispatch(
                {
                  type: TIMELINE_HAS_MORE,
                  payload: false
                }
              )
            );
          }
        })
        .catch(reject);
    });
  };
}

/**
 * Reset the timeline.
 * This will empty the timeline.
 * @returns {object} reset timeline action
 */
export function resetTimeline() {
  return {type: TIMELINE_RESET};
}

/**
 * Loads more timeline items
 * @param {int} page - page
 * @returns {function(dispatch): Promise<any>} promised thunk to be dispatched
 */
export function loadMore(page) {
  return (dispatch) => {
    return new Promise((resolve) => {
      resolve(
        dispatch(
          getTimeline(
            (page - 1) * TIMELINE_LIST_LIMIT
          )
        )
      );
    });
  }
}
